import { gql } from 'apollo-angular'

export const GET_USER_MAGAZINES = gql`
  query userMagazines {
    userMagazines {
      magazines {
        id
        title
        archived
        media {
          cover {
            url
          }
        }
      }
    }
  }
`
